import BaseCertificateWidget, { CERT_ACTIONS } from "widgets/project/BaseCertificateWidget";

class GenerateUnsignedCertificateWidget extends BaseCertificateWidget {
  bind() {
    this.bindBase();

    this.root.on("click", ".generate-unsigned-certificate", (e) => {
      const btn = $(e.currentTarget);
      this.checklistId = btn.data("checklist_id");
      this.activeBtn = btn;
      this.activeContainer = btn.closest('[id^="cert-action-"]');
      this.generate();
    });
  }

  generate() {
    this.disableContainer(this.activeContainer);
    this.spinner().removeClass("d-none");
    $.ajax({
      url: `${this.baseUrl}/checklists/${this.checklistId}/generate_unsigned_certificate`,
      type: "PUT",
      dataType: "json",
      success: () => {
        this.watchStatus();
      },
      error: (error) => {
        console.log(error);
        this.spinner().addClass("d-none");
        this.enableContainer(this.activeContainer);
      },
    });
  }

  checkStatus() {
    $.ajax({
      url: `${this.baseUrl}/checklists/${this.checklistId}/unsigned_certificate_status`,
      type: "GET",
      dataType: "json",
      success: (response) => {
        if (response.state === "ready" && !this.isTerminalFailure(response)) {
          this.stopWatchingStatus();
          this.spinner().addClass("d-none");
          this.statusMessage().addClass("d-none");
          this.fetchAndShowAction();
        } else {
          this.handleJobStatusResponse(response);
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  spinner() {
    return this.activeBtn.find(".js-generate-unsigned-cert-spinner");
  }
}

export { CERT_ACTIONS };
export default GenerateUnsignedCertificateWidget;
